/** The shape every status config map shares. */
export interface StatusConfig {
  label: string;
  className: string;
}

/** Neutral on purpose, and not a colour any known status uses. */
const UNKNOWN_CLASS = 'bg-gray-100 text-gray-700 border-gray-300';

/**
 * The config to use for a status value this build has no entry for.
 *
 * `jobs.status`, `jobs.job_card_status` and `jobs.invoice_status` are plain
 * `text` columns with no database constraint, so the typed union at the API
 * boundary is a claim rather than a guarantee. A value can arrive from a newer
 * deploy, an import script, or — as actually happened — an unmerged branch
 * writing to a shared development database.
 *
 * Indexing the config Record and dereferencing it blind turns that into
 * "Cannot read properties of undefined (reading 'className')", which React
 * escalates to a blank page: one unrecognised row takes out the entire list.
 *
 * The label is the raw value, humanised, rather than the word "Unknown" —
 * the office can then see what the job actually says even on a build that
 * does not know the status yet.
 */
export function unknownStatusConfig(value: string): StatusConfig {
  const label = value
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return { label: label || 'Unknown', className: UNKNOWN_CLASS };
}
